module.exports = __webpack_public_path__ + "img/ispass.37437bad.png";